<form [id]="'custContactForm_'+randomGuid" #custContactForm="ngForm" class="container">
  @if (!(token && token.userType == UserTypes.Customer)) {
  <div style="float: right">
    <p-button [disabled]="!canEdit" type="button" icon="pi pi-trash" (click)="delete()" severity="danger">
    </p-button>
  </div>
  }
  <div class="row columnPadding" style="padding-top: 0px;">
    <div class="col-3">
      @if (!smallerHeaders) {
      <h6>First Name</h6>
      }
      @if (smallerHeaders) {
      <div class="rfq-header">First Name</div>
      }
      @if (customerContact) {
      <input pInputText fluid [disabled]="!canEdit" [(ngModel)]="customerContact.firstName" [name]="'FN_'+randomGuid"
        required />
      }
    </div>
    <div class="col-3">
      @if (!smallerHeaders) {
      <h6>Last Name</h6>
      }
      @if (smallerHeaders) {
      <div class="rfq-header">Last Name</div>
      }
      @if (customerContact) {
      <input pInputText fluid [disabled]="!canEdit" [(ngModel)]="customerContact.lastName" [name]="'LN_'+randomGuid"
        required />
      }
    </div>
    <div class="col-4">
      @if (!smallerHeaders) {
      <h6> {{customerTypeId == customerTypesEnum.Residential ? 'Relationship' : 'Position'}}</h6>
      }
      @if (smallerHeaders) {
      <div class="rfq-header"> {{customerTypeId == customerTypesEnum.Residential ? 'Relationship' : 'Position'}}</div>
      }
      @if (customerContact) {
      <input pInputText fluid [disabled]="!canEdit" [(ngModel)]="customerContact.position"
        [name]="'position_'+randomGuid" />
      }
    </div>
    @if (!(token && token.userType == UserTypes.Customer)) {
    <div class="col-2">
      @if (!smallerHeaders) {
      <h6>Can Login</h6>
      }
      @if (smallerHeaders) {
      <div class="rfq-header">Can Login</div>
      }
      @if (customerContact) {
      <p-checkbox binary="true" [disabled]="!canEdit || (token && token.userType == UserTypes.Customer)"
        [(ngModel)]="customerContact.canLogin" [name]="'canLogin_'+randomGuid">
      </p-checkbox>
      }
    </div>
    }
    <div class="col-3">
      @if (!smallerHeaders) {
      <h6>Phone Number</h6>
      }
      @if (smallerHeaders) {
      <div class="rfq-header">Phone Number</div>
      }
      @if (customerContact && canEdit) {
      <input pInputText fluid mask="(000) 000-0000" placeholder="(     )      -" [style]="{'width': '100%'}"
        [(ngModel)]="customerContact.phoneNumber" [name]="'phone_'+randomGuid" />
      }
      @if (customerContact && !canEdit) {
      <input pInputText fluid placeholder="{{customerContact.phoneNumber | phoneNumber}}" [style]="{'width': '100%'}"
        disabled />
      }
    </div>
    <div class="col-3">
      @if (!smallerHeaders) {
      <h6>Email</h6>
      }
      @if (smallerHeaders) {
      <div class="rfq-header">Email</div>
      }
      @if (customerContact) {
      <input pInputText fluid [disabled]="!canEdit" (blur)="emailChanged(customerContact.emailAddress)"
        [(ngModel)]="customerContact.emailAddress.email" [name]="'Email_'+randomGuid" required email />
      }
    </div>
    @if (!isCustomer) {
    <div class="col-6">
      @if (!smallerHeaders) {
      <h6>Notes</h6>
      }
      @if (smallerHeaders) {
      <div class="rfq-header">Notes</div>
      }
      @if (customerContact) {
      <p-inputgroup>
        <input pInputText fluid [disabled]="!canEdit" [(ngModel)]="customerContact.notes"
          [name]="'Notes_'+randomGuid" />
        <p-inputgroup-addon>
          <p-button [disabled]="!canEdit" type="button" severity="secondary" class="input-group-icon-btn"
            icon="pi pi-ellipsis-v" (click)="openNotes()"></p-button>
        </p-inputgroup-addon>
      </p-inputgroup>
      }
    </div>
    }
    @if (!(token && token.userType == UserTypes.Customer)) {
    <div class="col-2">
      @if (!smallerHeaders) {
      <h6>Receive Non-Invoicing Emails</h6>
      }
      @if (smallerHeaders) {
      <div class="rfq-header">Receive Non-Invoicing Emails</div>
      }
      @if (customerContact) {
      <p-checkbox binary="true" [disabled]="!canEdit || (token && token.userType == UserTypes.Customer)"
        [(ngModel)]="customerContact.receiveNonInvoicingEmails" [name]="'nonInvoicing_'+randomGuid">
      </p-checkbox>
      }
    </div>
    }
    @if (!(token && token.userType == UserTypes.Customer)) {
    <div class="col-2">
      @if (!smallerHeaders) {
      <h6>Receive Invoicing Emails</h6>
      }
      @if (smallerHeaders) {
      <div class="rfq-header">Receive Invoicing Emails</div>
      }
      @if (customerContact) {
      <p-checkbox binary="true" [disabled]="!canEdit || (token && token.userType == UserTypes.Customer)"
        [(ngModel)]="customerContact.receiveInvoicingEmails" [name]="'invoicing_'+randomGuid">
      </p-checkbox>
      }
    </div>
    }
  </div>
</form>

<!-- Edit contact notes dialog -->
@if (displayNotesDialog) {
<div>
  <p-dialog header="Notes" [(visible)]="displayNotesDialog" [modal]="true" [resizable]="false" [baseZIndex]="11000"
    [style]="{'width': '600px'}" [focusOnShow]="false" (onHide)="closedNotesDialog(false)" [closable]="false"
    appendTo="body">
    <p-header>
      <a class="ui-dialog-titlebar-icon ui-dialog-titlebar-close ui-corner-all" tabindex="0" role="button"
        (click)="closedNotesDialog(false)" (keydown.enter)="closedNotesDialog(false)"
        (mousedown)="closedNotesDialog(false)">
        <span><i class="pi pi-times"></i></span>
      </a>
    </p-header>
    <textarea pInputText fluidarea [(ngModel)]="editedNote" [disabled]="!canEdit" [rows]="12" style="width: 100%;"
      placeholder="" [name]="'NotesDialog_'+randomGuid">
        </textarea>
    <div class="footer">
      <p-button type="button" severity="info" (click)="closedNotesDialog(false)" label="Cancel"></p-button>
      &nbsp;
      <p-button type="button" severity="success" (click)="closedNotesDialog(true)" label="Save"></p-button>
    </div>
  </p-dialog>
</div>
}